import { Box, Button, Stack, Typography } from "@mui/material";
import { Component, type ErrorInfo, type ReactNode } from "react";
import i18n from "@/shared/i18n/i18n";

type Props = { children: ReactNode };

type State = {
  hasError: boolean;
  message?: string;
};

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("AppErrorBoundary", error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <Box
          role="alert"
          sx={{
            minHeight: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 3,
          }}
        >
          <Stack spacing={2} maxWidth={480} textAlign="center">
            <Typography variant="h5" component="h1">
              {i18n.t("errors.boundaryTitle", { ns: "common" })}
            </Typography>
            {this.state.message ? (
              <Typography variant="body2" color="text.secondary">
                {this.state.message}
              </Typography>
            ) : null}
            <Button
              variant="contained"
              onClick={() => {
                window.location.reload();
              }}
            >
              {i18n.t("errors.reload", { ns: "common" })}
            </Button>
          </Stack>
        </Box>
      );
    }

    return this.props.children;
  }
}
